import React, { useState, useEffect } from "react";
import EditShiftModal from '../../modals/requestEditShift';
import ModalWrapper from '../../Modal';
import { getRequest } from "../../service/index";
import { parseToUserTz } from "../../utils/dateTime";
import { Pagination } from "antd";

const EntryTable = (props) => {
  const attendanceData = props.attendanceData || [];
  const [requestShifts, setRequestShifts] = useState([]);
  const [editShiftModalOpen, setEditShiftModalOpen] = useState(false);
  const [selectedEntry, setSelectedEntry] = useState(null);
  const [current, setCurrent] = useState(1);
  const pageSize = 3;

  // Fetch request shifts on mount
  useEffect(() => {
    fetchRequestShifts();
  }, []);

  const fetchRequestShifts = async () => {
    try {
      const response = await getRequest("/api/requestshift");
      setRequestShifts(response.requestShifts || []);
    } catch (error) {
      setRequestShifts([]);
    }
  };
  // Get all attendanceLog._id that already have a request
  const requestedAttendanceLogIds = new Set(
    requestShifts.map(rs => rs.attendanceLog?._id)
  );

  // Helper to check if date is today
  const isToday = (dateStr) => {
    if (!dateStr) return false;
    const entryDate = new Date(dateStr);
    const today = new Date();
    return entryDate.toDateString() === today.toDateString();
  };

  // Only show missing entries that do NOT have a request and are NOT from today
  const missingEntries = attendanceData.filter(
    (entry) =>
      entry.status === "Missing" && 
      !requestedAttendanceLogIds.has(entry._id) &&
      !isToday(entry.date)
  );

  // Pagination logic
  const startIdx = (current - 1) * pageSize;
  const endIdx = startIdx + pageSize;
  const pageData = missingEntries.slice(startIdx, endIdx);

  // Helper to format date as "DD MMM YY"
  const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    const parsed = parseToUserTz(dateStr);
    if (!parsed?.isValid()) return "-";
    return parsed.format("DD MMM YY");
  };

  // Open modal and set selected entry
  const handleEditClick = (entry) => {
    setSelectedEntry(entry);
    setEditShiftModalOpen(true);
  };

  // Close modal
  const handleCloseEditShiftModal = () => {
    setEditShiftModalOpen(false);
    setSelectedEntry(null);
  };

  // Optional: Refresh data after success
  const handleEditSuccess = () => {
    if (props.fetchAttendanceData) {
      props.fetchAttendanceData();
    }
    fetchRequestShifts()
    handleCloseEditShiftModal();
  };

  return (
    <>
      <table className="w-full bg-white text-[14px] whitespace-nowrap">
        <thead>
          <tr className="text-left border-b border-gray-200">
            <th className="px-2 py-2 md:px-4 md:py-2 font-semibold text-primary">Date</th>
            <th className="px-2 py-2 md:px-4 md:py-2 font-semibold text-primary">In</th>
            <th className="px-2 py-2 md:px-4 md:py-2 font-semibold text-primary">Out</th>
            <th className="px-2 py-2 md:px-4 md:py-2 font-semibold text-primary">Status</th>
          </tr>
        </thead>
        <tbody>
          {pageData.length === 0 ? (
            <tr>
              <td colSpan={4} className="px-2 py-2 md:px-4 text-gray-500 text-center">
                No missing entries found.
              </td>
            </tr>
          ) : (
            pageData.map((entry, index) => (
              <tr
                key={entry._id || index}
                className="border-b border-gray-200 cursor-pointer hover:bg-gray-100"
                onClick={() => handleEditClick(entry)}
              >
                <td className="px-2 py-2 md:px-4 md:py-2 text-gray-700">{formatDate(entry.date)}</td>
                <td className="px-2 py-2 md:px-4 md:py-2 text-gray-700">{entry.checkIn && entry.checkIn !== "-" && entry.checkIn !== "ss" ? entry.checkIn.slice(0, 5) : "-"}</td>
                <td className="px-2 py-2 md:px-4 md:py-2 text-gray-700">{entry.checkOut && entry.checkOut !== "-" && entry.checkOut !== "ss" ? entry.checkOut.slice(0, 5) : "-"}</td>
                <td className="px-2 py-2 md:px-4 md:py-2 text-primary">{entry.status}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
      <div className="flex justify-end mt-4 w-full">
        <Pagination
          current={current}
          pageSize={pageSize}
          total={missingEntries.length}
          onChange={setCurrent}
          showSizeChanger={false}
          className="!w-auto"
        />
      </div>
      <ModalWrapper
        open={editShiftModalOpen}
        onRequestClose={handleCloseEditShiftModal}
        title="Request Edit Shift"
      >
        <EditShiftModal
          onClose={handleCloseEditShiftModal}
          onSuccess={handleEditSuccess}
          initialData={selectedEntry || {}}
        />
      </ModalWrapper>
    </>
  );
};

export default EntryTable;
